export default {
  NEW: {
    value: 'new',
    label: '新品'
  },
  SPECIAL: {
    value: 'special',
    label: '特价品'
  },
  PURCHASE_LIMIT: {
    value: 'purchase_limit',
    label: '限购'
  },
  NUM_LIMIT: {
    value: 'num_limit',
    label: '限量'
  },
  NO_PACKAGING: {
    value: 'no_packaging',
    label: '无包装'
  },
  NO_INSTRUCTION: {
    value: 'no_instruction',
    label: '无说明书'
  }
}
